export const WellbeingResultsActionTypes = {
  FETCH_WELLBEING_RESULTS: "FETCH_WELLBEING_RESULTS",
  FETCH_WELLBEING_RESULTS_SUCCESS: "FETCH_WELLBEING_RESULTS_SUCCESS",
};
